export namespace KitTranslations {
  export const common = {
    kitManaged: 'kitManaged',
  } as const;

  export const error = {
    kitWithIdentifierAlreadyExistsError: 'kitWithIdentifierAlreadyExistsError',
  } as const;

  export const featureToggles = {
    kitKitFeatureToggleTitle: 'kitKitFeatureToggleTitle',
    kitKitFeatureToggleExplanation: 'kitKitFeatureToggleExplanation',
    kitRefillKitsFeatureToggleTitle: 'kitRefillKitsFeatureToggleTitle',
    kitRefillKitsFeatureToggleExplanation: 'kitRefillKitsFeatureToggleExplanation',
  } as const;
}
